module.exports = __webpack_public_path__ + "static/media/clock.f798f96d.svg";